module.exports = __webpack_public_path__ + "static/mission-img-1-956d4768423f0635e86740efbb863bfb.jpg";